export const LOGIN_QUERY_PARAMS = {
    REDIRECT_LOGIN_TOKEN: 'redirect_login_token',
    JOURNEY_ID: 'journey_id',
    LOCAL_ADDRESS: 'local_address',
    // Set by the shop server component when boot/offers return 401/403, signalling
    // that the persisted auth was rejected. The login page uses it to purge the
    // stale token instead of auto-redirecting back to /shop (which caused an
    // infinite shop <-> login redirect loop).
    SESSION_EXPIRED: 'session_expired',
} as const;

/** sessionStorage key — store-frontend `ELocalStorageKeys.JWT_PARAM` */
export const JWT_SESSION_STORAGE_KEY = '__ac_jwt';

export const URL_PARAMS = {
    JWT_PARAM: 'acjwt',
    D10X_PAYLOAD: 'd10x_payload',
    SOURCE: 'source',
} as const;

export const FAILED_PAGE_QUERY_PARAMS = {
    ERROR: 'error',
    MESSAGE: 'msg',
    ORDER_ID: 'orderId',
    CURRENCY_CODE: 'currencyCode',
    IS_IFRAME: 'isIframe',
    TITLE: 'title',
    /** Set by buildFailedLoginUrl, so a failure can be attributed to a method. */
    AUTH_METHOD: 'authMethod',
} as const;